
import mockData from './mock-data.js';

export default {
  name: 'owner-profile',
  data: function () {
    return {
      item: null,
      form: this.emptyForm()
    };
  },
  computed: {
    isCorpAccount: function () {
      return !!(this.item && this.item.account_type && this.item.account_type !== 'owner');
    },
    isCorpView: function () {
      return this.isCorpAccount;
    },
    genderText: function () {
      if (this.isCorpAccount) return '企業';
      return this.form.gender || '男';
    },
    hasBirthday: function () {
      return !!(this.form.birthYear || this.form.birthMonth || this.form.birthDay);
    },
    showFlag: function () {
      var n = String(this.form.nationality || '').trim().toLowerCase();
      if (!n) return true;
      return n === '日本' || n === 'jp' || n === 'jpn' || n === 'japan';
    }
  },
  created: function () {
    this.loadMe();
  },
  watch: {
    '$route.query.mock': function () {
      this.loadMe();
    }
  },
  methods: {
    emptyForm: function () {
      return {
        name: '',
        companyName: '',
        representative: '',
        accountNo: '',
        loginId: '',
        registeredAt: '',
        contractStart: '',
        accountType: '',
        contractYears: '',
        bankName: '',
        bankBranch: '',
        bankAccountNo: '',
        bankAccountName: '',
        invoiceRegNo: '',
        gender: '',
        nationality: '',
        phone: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        email: '',
        post1: '',
        post2: '',
        address: '',
        oldPassword: '',
        newPassword: ''
      };
    },
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    pad2: function (value) {
      var s = String(value || '');
      if (!s) return '';
      return s.length === 1 ? '0' + s : s;
    },
    formatDate: function (value) {
      if (!value) return '';
      return String(value).replace(/-/g, '.').slice(0, 10);
    },
    splitBirthday: function (value) {
      var raw = String(value || '').replace(/\./g, '-').slice(0, 10);
      var parts = raw.split('-');
      return {
        y: parts[0] || '',
        m: parts[1] || '',
        d: parts[2] || ''
      };
    },
    splitPostcode: function (value) {
      var digits = String(value || '').replace(/[^0-9]/g, '');
      return {
        p1: digits.slice(0, 3),
        p2: digits.slice(3, 7)
      };
    },
    applyItem: function (item) {
      this.item = item;
      var birth = this.splitBirthday(item.birthday);
      var post = this.splitPostcode(item.postcode);
      var years = item.contract_years;
      this.form.name = item.name || ((item.lastname || '') + (item.firstname || ''));
      this.form.companyName = item.company_name || '';
      this.form.representative = item.representative || '';
      this.form.accountNo = item.account_no || '';
      this.form.loginId = item.username || item.email || '';
      this.form.registeredAt = this.formatDate(item.registered_at);
      this.form.contractStart = this.formatDate(item.contract_start);
      this.form.accountType = item.account_type_label
        || (item.account_type === 'owner' ? 'オーナー' : (item.account_type ? '法人' : ''));
      this.form.contractYears = years === null || years === undefined || years === '' ? '' : (String(years).indexOf('年') > -1 ? String(years) : years + '年');
      this.form.bankName = item.bank_name || '';
      this.form.bankBranch = item.bank_branch || '';
      this.form.bankAccountNo = item.bank_account_no || '';
      this.form.bankAccountName = item.bank_account_name || '';
      this.form.invoiceRegNo = item.invoice_reg_no || '';
      this.form.gender = item.gender || '';
      this.form.nationality = item.nationality || '';
      this.form.phone = item.phone || '';
      this.form.birthYear = birth.y;
      this.form.birthMonth = birth.m;
      this.form.birthDay = birth.d;
      this.form.email = item.email || '';
      this.form.post1 = post.p1;
      this.form.post2 = post.p2;
      this.form.address = item.address || '';
      this.form.oldPassword = '';
      this.form.newPassword = '';
    },
    isMock: function () {
      var q = this.$route && this.$route.query && this.$route.query.mock;
      return String(q) === '1' || String(q) === 'corp';
    },
    isCorpMock: function () {
      return !!(this.$route && this.$route.query && String(this.$route.query.mock) === 'corp');
    },
    applyMock: function () {
      var corp = this.isCorpMock();
      var p = corp ? Object.assign({}, mockData.profile, mockData.corpProfile) : mockData.profile;
      this.applyItem({
        name: p.name,
        company_name: p.companyName || '',
        representative: p.representative || '',
        account_no: p.accountNo,
        username: p.loginId,
        email: p.email,
        registered_at: String(p.registeredAt || '').replace(/\./g, '-'),
        contract_start: String(p.contractStart || '').replace(/\./g, '-'),
        account_type: corp ? 'corp' : 'owner',
        account_type_label: p.accountType,
        contract_years: p.contractYears,
        bank_name: p.bankName,
        bank_branch: p.bankBranch,
        bank_account_no: p.bankAccountNo,
        bank_account_name: p.bankAccountName,
        invoice_reg_no: p.invoiceRegNo,
        gender: p.gender,
        nationality: p.nationality,
        phone: p.phone,
        birthday: p.birthYear + '-' + p.birthMonth + '-' + p.birthDay,
        postcode: (p.post1 || '') + (p.post2 || ''),
        address: p.address
      });
    },
    loadMe: function () {
      if (this.isMock()) {
        this.applyMock();
        return;
      }
      var t = this;
      axios.get('landlord/me').then(function (res) {
        if (res.data.status == 1 && res.data.options && res.data.options.item) {
          t.applyItem(res.data.options.item);
        }
      });
    },
    goContract: function () {
      this.$router.push('/owner/contract');
    }
  }
};
